/**
 * Modal / banner facade.
 *
 * This module used to hold Batch 2's ad-hoc window.confirm + toast
 * fallbacks. Batch 4 Task 10 replaced those with real UI in
 * src/components/*. This file is now a thin re-export so:
 *
 *   1. Every existing caller (home.js, editor.js, main.js) keeps
 *      importing from './ui/modal-stubs.js' unchanged.
 *   2. Batch 3's test spy strategy (vi.spyOn on the module namespace
 *      resolved from '../ui/modal-stubs.js') continues to work
 *      because the `import * as / export const` pattern below
 *      produces writable/configurable bindings on THIS module's
 *      namespace object — the kind `vi.spyOn` can override at
 *      runtime.
 *
 * IMPORTANT — do NOT rewrite these exports to the shorter
 * `export { foo } from '../components/foo.js'` re-export form.
 * ESM pure re-exports create *live read-only* bindings on the
 * namespace object, which `vi.spyOn(modalStubs, 'foo')` cannot
 * replace in several real-world Vitest ESM configurations. The
 * `import * as _ns / export const foo = _ns.foo` pattern below
 * is the preferred form and is used upfront to avoid a
 * failing-test round-trip during Batch 3 re-verification.
 *
 * If you need to add a NEW modal/banner, add the component under
 * src/components/ and re-export it here using the same pattern —
 * do NOT introduce a new import path into screen code.
 */

import * as _resumeModal from '../components/resume-modal.js';
import * as _confirmDialog from '../components/confirm-dialog.js';
import * as _importDialog from '../components/import-dialog.js';
import * as _updateBanner from '../components/update-banner.js';
import * as _installBanner from '../components/install-banner.js';
import * as _storageWarning from '../components/storage-warning.js';
import * as _offlineIndicator from '../components/offline-indicator.js';

export const showResumeModal = _resumeModal.showResumeModal;
export const showConfirmDialog = _confirmDialog.showConfirmDialog;
export const showImportDialog = _importDialog.showImportDialog;
export const mountUpdateBanner = _updateBanner.mountUpdateBanner;
export const mountInstallBanner = _installBanner.mountInstallBanner;
export const mountPrivateBrowsingBanner = _storageWarning.mountPrivateBrowsingBanner;
export const mountMigrationFailureBanner = _storageWarning.mountMigrationFailureBanner;
export const setOfflineIndicator = _offlineIndicator.setOfflineIndicator;
